import styles from "./textWrapper.module.css";

const TextWrapper = ({ textStyle, children }) => {
  return (
    <div className={`${styles[textStyle]} ${styles.container}`}>{children}</div>
  );
};

export default TextWrapper;
